import {  Component,  Input,  OnInit, } from '@angular/core';
import { Supplier, SearchSuppliersParameters,PS_Search_Suppliers_Result, SimpleReponseResult }  from '../../all-models';
import { SharedDataService, SuppliersService } from '../../all-services';


@Component({
  selector: 'num-tiers',
  templateUrl: './num-tiers.component.html',
  styleUrls: ['./num-tiers.component.scss']
})
export class NumTiersComponent implements OnInit {

  @Input() supplier?:Supplier = null;
  public editing: boolean= false;
  constructor(
    private suppliersSvc: SuppliersService,
    public sharedDataSvc: SharedDataService
  ) { }

  ngOnInit(): void {
  }

  get canEdit():boolean{
    return ['ADMIN','COMPTA'].indexOf(this.sharedDataSvc.profil?.Cod)>=0;
  }

  
  private memValue:string=null;
  edit():void{
    if (this.canEdit) {
      this.memValue = this.supplier?.NumTiers;
      this.editing = true;
    }
  }



  save(step: number = 1):void{
    if ( !this.supplier?.Id) return;
    if ((step||1)==1 && !!(this.supplier.NumTiers)){
      //On commence par vérifier l'unicité du n° tiers. Si pas unique, on affiche un popup d'alerte
      let searchParam: SearchSuppliersParameters = new SearchSuppliersParameters();
      searchParam.NumTiers = this.supplier.NumTiers;
      this.suppliersSvc.getSuppliers(searchParam).subscribe((results:PS_Search_Suppliers_Result[])=>{
        if (results.find(r=>r.Id!=this.supplier.Id)){
          this.sharedDataSvc.pafConfirm('MSG_NUMTIERS_EXISTANT',():void=>{this.save(2)},():void=>{this.cancel()});
        } else {
          this.save(2);
        }
        return;
      });
      return;
    }
    else {
      let patchParam:Supplier=new Supplier();
      patchParam.Id=this.supplier.Id;
      patchParam.NumTiers = this.supplier.NumTiers;
      this.suppliersSvc.PatchSimpleValues(this.supplier.Id,patchParam,'NumTiers')
      .subscribe({
        next:(result:SimpleReponseResult)=>{  
          if (result.Ok) {
            this.editing  = false;
          }      
        },
        error:(reason)=>this.sharedDataSvc.alertSubscriptionReject(reason)
      });
    }
  }

  cancel():void{
    if (this.supplier){
      this.supplier.NumTiers = this.memValue;
    }
    this.editing  = false;
  }
}

